module.exports = __webpack_public_path__ + "img/slider-image-01-pluska.a8ddab58.png";